
import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class AssetProductCategory extends BaseEntity {
  
  assetProductCategoryCode: string;
  name                    : string;
  rank                    : number;

  constructor() {
   super()
  }
  
}
